const ASSISTANT_PARTICIPANT_PREFIX = 'assistant:';

/** A person's working assistant, listed next to them among the participants. */
export function assistantParticipantId(ownerId: string): string {
  return `${ASSISTANT_PARTICIPANT_PREFIX}${ownerId}`;
}

/** Participants without an account of their own: their name travels with their presence. */
export function carriesOwnName(participantId: string): boolean {
  return (
    participantId.startsWith('external-doc-access:') ||
    participantId.startsWith(ASSISTANT_PARTICIPANT_PREFIX)
  );
}
